<template>
  <div class="mt-0">
    <auto-form :value="fields" ></auto-form>
    <v-divider></v-divider>
    <v-data-table :items="item?.data" :headers="viewHeaders" dense>
      <template #item.imageUrl1="{ item }">
        <v-img v-if="item.imageUrl1" width="64px" :src="item.imageUrl1"></v-img>
        <v-img v-if="item.imageUrl2" width="64px" :src="item.imageUrl2"></v-img>
        <v-img v-if="item.imageUrl3" width="64px" :src="item.imageUrl3"></v-img>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import AutoForm from '../../../components/CommonView/AutoForm.vue';
import * as moment from "moment/moment";
import { detailHeaders } from './header'
export default {
  props: {
    item: {
      type: Object
    },
  },
  components: {
    AutoForm
  },
  computed: {
    fields () {
      let base = [
        {name: 'storeAlias', label:'Alias Store', type: 'text-field', value: this.item?.root?.storeAlias, cols: 12, md:6 },
        {name: 'storeName', label:'Tên store', type: 'text-field', value: this.item?.root?.storeName, cols: 12, md:6 },
        {name: 'storeAddress', label:'Địa chỉ store', type: 'text-field', value: this.item?.root?.storeAddress, cols: 12, md:6 },
        {name: 'createdAt', label:'Checkin vào', type: 'text-field', value: this.$formatter.formatDate(this.item?.root?.createdAt, 'HH:mm:ss DD/MM/YYYY'), cols: 12, md:6 },
        {name: 'createdByCode', label:'Mã NS checkin', type: 'text-field', value: this.item?.root?.createdByCode, cols: 12, md:6 },
        {name: 'createdByName', label:'Người checkin', type: 'text-field', value: this.item?.root?.createdByName, cols: 12, md:6 },
        {name: 'address', label:'Địa điểm khác(nếu có)', type: 'text-field', value: this.item?.root?.address, cols: 12, md:6 },
        {name: 'checkout', label:'CheckOut', type: 'autocomplete', value: this.item?.root?.status, cols: 12, md:6, items: [
          {text: 'Chưa checkout', value: 0},
          {text: 'Đã checkout', value: 1}
        ] },
        {name: 'description', label:'Mô tả khác', type: 'text-field', value: this.item?.root?.description, cols: 12, md:12 },
      ]
      if(this.item) {
        return [
          {name: 'id', label:'Id', type: 'text-field', value: this.item?.root?.id, cols: 12 },
          ...base
        ]
      }else {
        return base
      }
    },
    
    viewHeaders () {
      return detailHeaders([])
    }
  },
  data() {
    return {
      // slots: ['score']
    }
  },
  methods: {

  }

}
</script>